<template>
  <div>
    <ImportDialog
      :importProcessLoading="importProcessLoading"
      :importingErrors="importingErrors"
      @close="importProcessLoading = false"
    />
    <v-container fluid>
      <v-card elevation="0" class="ma-0">
        <v-card-title class="secondary--text font-weight-medium pt-5">
          <v-row align="center" no-gutters class="ma-0" justify="end">
            <v-col cols="12">
              <h3 class="my-2 primary--text">
                {{ $t("layout.user") }}
              </h3>
            </v-col>
            <!-- <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer> -->
            <v-col cols="3">
              <v-text-field
                :label="$t('common.search')"
                v-model="search"
                :placeholder="$t('common.nameEmailPhone')"
                class="my-2 custom-label-color"
                hide-details="auto"
                outlined
                dense
              >
              </v-text-field>
            </v-col>
            <v-col cols="9" class="text-end">
              <v-btn
                v-on="item.on"
                v-bind="item.attrs"
                class="ml-2 white--text"
                color="primary"
                v-for="(item, index) in menuItems"
                :key="index"
              >
                <v-icon class="mr-1">{{ item.icon }}</v-icon>
                <span>{{ item.text }}</span>
              </v-btn>
            </v-col>
          </v-row>
          <!-- menuItems -->
          <!-- <v-menu bottom>
              <template #activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon class="my-2">
                  <v-icon>mdi-menu</v-icon>
                </v-btn>
              </template>
              <v-card> -->
          <!-- file input for importing excel file with users -->
          <!-- <v-file-input
                  v-show="false"
                  ref="importUsersExcel"
                  v-model="fileForImport"
                  @change="uploadFileForImportingUsers"
                  accept=".xlsx,.xls"
                >
                </v-file-input>
                <v-list-item
                  v-for="(listItem, index) in menuItems"
                  v-on="listItem.on"
                  v-bind="listItem.attrs"
                  :key="index"
                >
                  <span class="text-body-2">
                    <v-icon class="mx-1" v-bind="listItem.iconProps">{{
                      listItem.icon
                    }}</v-icon>
                    {{ listItem.text }}
                  </span>
                </v-list-item>
              </v-card>
            </v-menu> -->
        </v-card-title>
        <!-- <div id="wrapper2">
          <div id="top-scroll" class="width-scroll-top"></div>
        </div> -->
        <v-data-table
          :footer-props="{ 'items-per-page-options': [50, 100, 150, 200, -1] }"
          class="mt-1 mb-9 datatable table-reference-for-scroll"
          :hide-default-footer="footer"
          id="customerTable"
          :headers="headers"
          :items="userLists"
          :search="search"
          :loading="loading"
          mobile-breakpoint="0"
          :options.sync="options"
          :server-items-length="totalUser"
        >
          <template v-slot:[`item._id`]="{ item }">
            <p class="my-0 py-0">
              {{
                options.page * options.itemsPerPage -
                  options.itemsPerPage +
                  userLists
                    .map(function(x) {
                      return x._id;
                    })
                    .indexOf(item._id) +
                  1
              }}
            </p>
          </template>
          <template v-slot:[`item.active`]="{ item }">
            <v-switch
              class="ma-0"
              value
              v-if="!footer"
              v-model="item.active"
              @click="showToggleDialog(item)"
              color="primary"
            ></v-switch>
            <span v-else>{{ item.active ? "true" : "false" }}</span>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-row class="mx-0">
              <v-icon
                class="mx-auto"
                color="primary"
                @click="editCustomer(item)"
              >
                mdi-pencil</v-icon
              >
            </v-row>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { changeCustomerStatus } from "../../methods/customer/changeCustomerStatus";
// import avatar from "vue-avatar";
// import AddButton from "../../../core/components/AddButton.vue";
export default {
  data() {
    return {
      footer: false,
      loading: false,
      search: "",
      variables: {
        limit: 10,
        skip: 0
      },
      options: {
        itemsPerPage: 50,
        page: 1
      },
      userLists: [],
      totalUser: 50,
      fileForImport: null,
      importProcessLoading: false,
      importingErrors: null
    };
  },
  components: {
    ImportDialog: () => import("./ImportDialog.vue")
  },
  computed: {
    menuItems() {
      return [
        {
          text: this.$t("customer.addCustomer"),
          icon: "mdi-plus",
          iconProps: {
            color: "green"
          },
          attrs: {},
          on: {
            click: () => this.openRightSideDrawer()
          }
        },
        // {
        //   text: this.$t("customer.otp.otpList"),
        //   icon: "mdi-format-list-text",
        //   iconProps: {
        //     color: "green",
        //   },
        //   attrs: {
        //     to: "/otp",
        //   },
        //   on: {},
        // },
        {
          text: this.$t("customer.exportCustomer"),
          icon: "mdi-application-export",
          iconProps: {
            color: "green"
          },
          attrs: {},
          on: {
            click: () => this.exportData()
          }
        },
        {
          text: this.$t("customer.importCustomer"),
          icon: "mdi-application-import",
          attrs: {
            // icon: true,
            loading: this.excelProcessLoading
          },
          iconProps: {
            color: "green"
          },
          on: {
            click: () => {
              this.$refs["importUsersExcel"].$refs.input.click();
            }
          }
        },
        {
          text: this.$t("landlord.downloadTemplateForImport"),
          icon: "mdi-file-excel",
          attrs: {
            // icon: true,
            loading: this.excelProcessLoading
          },
          iconProps: {
            color: "success"
          },
          on: {
            click: () => {
              const a = document.createElement("a");
              const url =
                "http://uploads.rentings.io/files/images/users/userImportSampleFile/customer_template.xls";
              a.download = url;
              a.style.display = "none";
              a.href = url;
              a.click();
            }
          }
        }
      ];
    },
    headers() {
      return [
        {
          text: "#",
          align: "left",
          value: "_id",
          sortable: false,
          width: 10
        },
        {
          text: this.$t("landlord.name"),
          align: "left",
          width: 40,
          value: "firstName"
        },
        {
          text: this.$t("landlord.email"),
          align: "left",
          width: 40,
          sortable: false,
          value: "email"
        },
        {
          text: this.$t("landlord.phoneNumber"),
          align: "left",
          width: 40,
          value: "phone",
          sortable: false
        },
        {
          text: this.$t("landlord.isActive"),
          align: "left",
          width: 40,
          value: "active",
          sortable: false
        },
        // {
        //   text: this.$t("customer.civilIdNumber"),
        //   sortable: false,
        //   align: "left",
        //   width: 40,
        //   value: "civilIdNumber"
        // },
        // {
        //   text: this.$t("common.createdDate"),
        //   sortable: false,
        //   width: 80,
        //   align: "left",
        //   value: "createdAt"
        // },
        // {
        //   text: this.$t("customer.civilIdImageBack"),
        //   sortable: false,
        //   align: "center",
        //   width: 80,
        //   value: "civilIdImageBack"
        // },
        {
          text: this.$t("common.action"),
          align: "left",
          width: 40,
          sortable: false,
          value: "action"
        }
      ].map(header => {
        header.align = "center";
        header.sortable = false;
        return header;
      });
    }
  },
  watch: {
    options(val) {
      this.$apollo.queries.searchCustomer.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalUser,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          searchKey: this.search,
          sortBy: val.sortBy[0],
          sortDesc: val.sortDesc[0]
        }
      });
    },
    search(val) {
      this.loading = true;
      this.$apollo.queries.searchCustomer.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalUser,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          searchKey: val
        }
      });
      this.loading = false;
    }
  },
  apollo: {
    searchCustomer() {
      this.loading = true;
      return {
        query: require("@/user/api/queries/customer/search_customer_query.graphql"),
        variables: {
          input: {
            limit: 50,
            skip: 0
          },
          filter: {
            searchKey: this.search,
            sortBy: "",
            sortDesc: false
          }
        },
        result({ data, loading }) {
          // , loading, networkStatus, refetch
          this.userLists = this.$format.cloneVariable(
            data.searchCustomer.users
          );
          this.totalUser = data.searchCustomer.totalCount;
          this.loading = loading;
        }
      };
    }
  },
  mounted() {
    let wrapper_1 = document.querySelector(
      ".table-reference-for-scroll .v-data-table__wrapper"
    );
    let wrapper_2 = document.querySelector("#wrapper2");
    wrapper_1.onscroll = function() {
      wrapper_2.scrollLeft = wrapper_1.scrollLeft;
    };

    wrapper_2.onscroll = function() {
      wrapper_1.scrollLeft = wrapper_2.scrollLeft;
    };

    this.$root.$on("customerTable", () => {
      this.options.itemsPerPage = 50;
      this.$set(this.options, this.options.itemsPerPage, 50);
    });
    this.$root.$on("toggleItems", data => {
      if (data.module === "users") {
        changeCustomerStatus({
          id: data.item._id,
          status: data.item.active
        }).then(({ data }) => {
          if (data.changeCustomerStatus) {
            this.$store.commit("TOGGLE_BTN_LOADING", false);
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: "Customer Status Changed Successfully",
              color: "green"
            });
            this.$root.$emit("refetchCustomer");
          }
        });
      }
    });
    this.$root.$on("refetchCustomer", () => {
      this.loading = true;
      this.$apollo.queries.searchCustomer.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalUser,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        }
        // filter: {
        //   searchKey: this.search,
        //   sortBy: '',
        //   sortDesc: ''
        // }
      });
      this.loading = false;
    });
  },
  methods: {
    uploadFileForImportingUsers() {
      this.importProcessLoading = true;
      const importFile = this.fileForImport;
      this.$apollo
        .mutate({
          mutation: require("@/user/api/mutations/import_customers.graphql"),
          variables: {
            importFile: importFile
          }
        })
        .then(({ data }) => {
          this.importProcessLoading = false;
          if (data.importCustomers) {
            this.$apollo.queries.searchCustomer.refetch({
              input: {
                limit:
                  this.options.itemsPerPage !== -1
                    ? this.options.itemsPerPage
                    : this.totalUser,
                skip:
                  this.options.page * this.options.itemsPerPage -
                  this.options.itemsPerPage
              }
            });
          } else {
            this.$store.commit("SHOW_SNACKBAR", {
              text: this.$t("landlord.importingFailed"),
              color: "error",
              show: true
            });
          }
        })
        .catch(error => {
          if (error.graphQLErrors.length > 0) {
            this.importingErrors = JSON.parse(error.graphQLErrors[0].message);
          }
        });
    },
    exportData() {
      this.$apollo.queries.searchCustomer
        .refetch({
          input: {
            limit: 0,
            skip: 0
          }
        })
        .then(response => {
          this.options.itemsPerPage = response.data.searchCustomer.totalCount;
          this.unitTypeLists = response.data.searchCustomer.users;
          this.footer = true;
          setTimeout(() => {
            this.htmlToExcel("customerTable", "customer");
          }, 1000);
        });
    },
    openRightSideDrawer() {
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
    },
    showDeleteDialog(item) {
      this.$root.$emit("deleteDialog", { dialog: true, item: item });
    },
    editCustomer(item) {
      this.$store.commit("IS_EDIT_CUSTOMER", true);
      this.$store.commit("EDIT_CUSTOMER", item);
      this.$store.commit("CUSTOMER_FORMNAME", "CUSTOMER");
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
    },
    showToggleDialog(item) {
      this.$root.$emit("toggleDialog", {
        dialog: true,
        item: item,
        module: "users"
      });
      this.$root.$emit("refetchCustomer");
    }
  },
  beforeDestroy() {
    this.$root.$off("customerTable");
    this.$root.$off("refetchCustomer");
    this.$root.$off("toggleItems");
  }
};
</script>
<style>
.v-input--switch .v-input--selection-controls__input {
  width: 38px;
  margin-left: auto;
  margin-right: auto;
}
.datatable >>> .v-data-footer__select {
  direction: ltr !important;
}
.datatable >>> .v-data-footer__pagination {
  direction: ltr !important;
}

/* This is the size of the path of the scrollbar */
#wrapper2 {
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
}

/* This div allow to make the scroll function and show the scrollbar */
#top-scroll {
  height: 1px;
  overflow: scroll;
}

/* This is the size of the scrollbar */
.width-scroll-top {
  width: 1800px;
}
</style>
